import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ContextSettingService } from '../context-setting.service';

@Component({
  selector: 'app-data-aggregated-options',
  templateUrl: './data-aggregated-options.component.html',
  styleUrls: ['./data-aggregated-options.component.css']
})
export class DataAggregatedOptionsComponent implements OnChanges {
  @Input() typeMultiValues: boolean = false;

  requiredInterval: boolean;
  requiredIntegralTimeUnit: boolean;

  disabledInterval: boolean;
  disabledInterpolation: boolean;
  disabledTimeUnit: boolean = true;

  aggregationTypesValue: string = "Min";
  intervalValue: string = "";
  interpolationValue: string = "";
  integralTimeUnitValue: string = "";

  constructor(private contextSettingService: ContextSettingService) { }

  ngOnChanges(): void {
    this.updateSettings(false);
  }

  updateSettings(reset: boolean, partiel: boolean = false): void {
    const isIntegral = this.aggregationTypesValue === 'Integral';
    const isMulti = this.typeMultiValues;

    this.disabledInterval = isIntegral ? !isMulti : false;
    this.requiredInterval = !isIntegral && isMulti;
    this.disabledInterpolation = isIntegral;
    this.disabledTimeUnit = !isIntegral;
    this.requiredIntegralTimeUnit = isIntegral;

    if (reset) {
      if (!partiel)
        this.aggregationTypesValue = "Min";
      this.intervalValue = "";
      this.interpolationValue = "";
      this.integralTimeUnitValue = "";
    }

    this.contextSettingService?.setSetting('aggregation', this.aggregationTypesValue);
    this.contextSettingService?.setSetting('interval', this.intervalValue);
    this.contextSettingService?.setSetting('interpolation', this.interpolationValue);
    this.contextSettingService?.setSetting('integralTimeUnit', this.integralTimeUnitValue);
  }
}
